module.exports = require("mp-ck-editor-5");